// import fs from 'fs';
// import Path from 'path';
// import { configIntegration } from "../midelware/config-integrate.js"
// import { createVueFile } from "../midelware/check-type.js"
import { createModule } from '../init/create-module.js';
const args = process.argv.slice(2);
if (args.length < 2) {
    console.error('Usage: npm run add-module -- <target-path> <module-name>');
    process.exit(1);
}

const targetPath = args[0]; // Custom path
const moduleName = args[1]; // Module name
const isStore = args.includes("store")
const isLayout = args.includes("layout")
const isI18n = args.includes("layout")
// Resolve the full path
// const modulePath = Path.resolve(process.cwd(), targetPath, moduleName);
const layer_conf = {
    targetPath, moduleName, isPages: true, isStore, isLayout, i18n: isI18n
}
createModule(layer_conf)
// Create the directory if it doesn't exist
// if (!fs.existsSync(modulePath)) {
//     fs.mkdirSync(modulePath, { recursive: true });
//     const component = Path.resolve(process.cwd(), `${modulePath}/components`);
//     const pages = Path.resolve(process.cwd(), `${modulePath}/pages`);
//     // const layout = Path.resolve(process.cwd(), `${modulePath}/layouts`);
//     fs.mkdirSync(component, { recursive: true });
//     fs.mkdirSync(pages, { recursive: true });
//     // fs.mkdirSync(layout, { recursive: true });
//     // path for config file
//     const configPath = Path.join(modulePath, 'nuxt.config.ts');
//     createVueFile(configPath, "config", `nuxt.config.ts`);
//     // path for page 
//     const pagePath = Path.join(modulePath, `pages/${moduleName}.vue`);
//     createVueFile(pagePath, "page", `${moduleName}`);
//     // // path for component 
//     const componentPath = Path.join(modulePath, `components/${moduleName}.vue`);
//     createVueFile(componentPath, "component", `component`);
//     // ask for layout if init it
//     if (isLayout) {
//         const LayoutDir = Path.resolve(process.cwd(), `${modulePath}/layouts`);
//         fs.mkdirSync(LayoutDir, { recursive: true });
//         const layoutFile = Path.join(modulePath, `layouts/${moduleName}-lay.vue.vue`);
//         createVueFile(layoutFile, "layout", `${moduleName}`);
//     }
//     // ask for store if init it
//     if (isStore) {
//         const storeDir = Path.resolve(process.cwd(), `${modulePath}/store`);
//         fs.mkdirSync(storeDir, { recursive: true });
//         const layoutFile = Path.join(modulePath, `store/${moduleName}Store.ts`);
//         createVueFile(layoutFile, "store", `${moduleName}`);
//     }
//     configIntegration(targetPath, moduleName);

//     // fs.mkdirSync(`${viewsDir}/pages`,);
//     // fs.mkdirSync(`${viewsDir}/layouts`);
//     // component path of module
//     // const componentPath = Path.join(viewsDir, `components/component.vue`);
//     // createVueFile(componentPath, "component", "component");
//     // const pagesPath = Path.join(viewsDir, `pages/${moduleName}.vue`);
//     // createVueFile(pagesPath, "page", `pages/${moduleName}.vue`);





//     // console.log(`Module "${moduleName}" created at: ${modulePath}`);

// } else {
//     console.error(`Module "${moduleName}" already exists at: ${modulePath}`);
// }